<template>
  <v-container>
    <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>
    <v-row>
      <v-col>
        <div>
          <v-row>
            <v-col class="d-flex flex-1 align-center justify-space-between pb-5">
              <span class="header bold text-tcdc-green">{{newsById[`title_${lang}`]}}</span>
              <ShareButton mode="news" :title="newsById[`title_${lang}`]"></ShareButton>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <span class="text-tcdc-grey1 bold mr-4">{{$t('onlineEx.publish')}} {{newsById[`publish_date_${lang}`] | moment('DD MMM YYYY')}}</span>
              <img src="../../assets/icons/generals/view.png" class="tcdc-view-icon mr-2" />
              <span class="text-tcdc-grey1 bold mr-4">{{formatNumber(newsById.viewer)}}</span>
            </v-col>
          </v-row>
          <v-row class="mb-5">
            <v-col>
              <v-img eager :src="newsById.image_path" aspect-ratio="1.91"></v-img>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <div class="vhtml" v-html="newsById[`description_${lang}`]">
              </div>
            </v-col>
          </v-row>

        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapState } from "vuex";
  import ShareButton from "../buttons/ShareButton";
  import {BreadcrumbUtil} from "@/util/BreadcrumbUtil";

  export default {
    components: {
      ShareButton
    },
    async created() {
      this.items = BreadcrumbUtil.setServiceItem(
          this.items,
          this.branchId,
          this.branchName,
          this.allBranches,
          this.lang
      )
      await this.$store.dispatch('About/getAboutNewsById', { id: this.$route.params.id, lang: this.lang });
    },
    methods: {
      formatNumber(num) {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
    },
    computed: {
      ...mapState({
        branchName: state => state.Branch.branch_name,
        branchId: state => state.Branch.branch_id,
        allBranches: state => state.Branch.branches,
        newsById: state => {
          if (state.About.newsById) {
            return state.About.newsById;
          }
        },
        lang: state => state.Branch.lang
      }),
      branchChanged: function () {
        return this.branchName;
      }
    },
    watch: {
      branchChanged: function() {
        this.items = BreadcrumbUtil.setServiceItem(
            this.items,
            this.branchId,
            this.branchName,
            this.allBranches,
            this.lang
        )
      }
    },
    data: () => ({
      items: [
        {
          text: 'TCDC BANGKOK',
          disabled: false,
          to: "/home/:branch"
        },
        {
          text: "ABOUT",
          disabled: false,
          to: "/:branch/about"
        },
        {
          text: "NEWS",
          href: "/:branch/about/news"
        }
      ]
    })
  };
</script>

<style scoped>
.eventdetail-card-logo {
  height: 25px;
  object-fit: contain;
}
</style>
